import React, { useState } from "react";
import { PageHeader } from "lift-ui";
import LogsTable from "./logs-table/logs-table.component";
import LogsDialog from "./logs-dialog/logs-dialog.component";

const AdverityLogs = () => {
  const [showLogsDialog, setShowLogsDialog] = useState(false);
  const [selectedLogId, setSelectedLogId] = useState<number | null>(null);

  const handleShowLogs = (id: number) => {
    setSelectedLogId(id);
    setShowLogsDialog(true);
  };

  return (
    <div className="flex flex-col h-full bg-white">
      <PageHeader title="Adverity Import" />

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-h-0 px-8 pt-8 pb-4">
        <div className="flex-1 min-h-0">
          <LogsTable onShowLogs={handleShowLogs} />
        </div>
      </div>

      <LogsDialog
        open={showLogsDialog}
        onClose={() => setShowLogsDialog(false)}
        importId={selectedLogId?.toString()}
      />
    </div>
  );
};

export default AdverityLogs;
